// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"1189":"editor","3161":"CustomWidgetBuilder"}[chunkId] || chunkId) + "." + {"1189":"ea0bfdc6","1823":"9eff334e","2436":"7a345a40","2541":"34901d22","2666":"369a759a","3161":"46e183d6","3285":"1ef3f7ac","4659":"17888482","5893":"2e3b0847","6526":"ef149505","8285":"7a4ff437"}[chunkId] + ".chunk.css";
};